import React from 'react';
import { Link } from 'react-router-dom';

const BreadcrumbOne = ({ title , rootUrl , parentUrl, currentUrl}) => {
    return (
        <section className="banner-section text-capitalize" style={{background: 'url(images/banner/bn-01-1920x480.png)'}}>
        <div className="banner-title">
            <h2 dangerouslySetInnerHTML={{__html: title}}></h2>
        </div>
        <div className="banner-link">
            <ul>
            <li><Link to={`${rootUrl}`} dangerouslySetInnerHTML={{__html: parentUrl}}></Link></li>
            <li dangerouslySetInnerHTML={{__html: currentUrl}}></li>
            </ul>
        </div>
        </section>
    )
}

export default BreadcrumbOne;